/*
 * @Author: Dong
 * @Date: 2022-05-14 13:03:47
 * @LastEditors: Dong
 * @LastEditTime: 2022-05-14 15:30:53
 */
import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react';

export const useUnMounted = () => {
  const unMounted = useRef(false);

  useEffect(() => {
    return () => {
      unMounted.current = true;
    };
  }, []);

  return useCallback(() => unMounted.current, []);
};

export const useAsyncState = <S,>(initState: (() => S) | S): [S, Dispatch<SetStateAction<S>>] => {
  const unMounted = useUnMounted();
  const [value, setValue] = useState<S>(initState);

  const setNewValue = useCallback((newValue) => {
    if (unMounted()) return;
    setValue(newValue);
  }, []);

  return [value, setNewValue];
};
